import { watch } from 'vue'
import { useMyOrganizations } from '@/features/organizations/queries/useMyOrganizations'
import { useWorkspaceStore } from '@/stores/workspace'

/** Loads the user's organizations/workspaces and keeps the workspace store in sync with them. */
export function useSyncMyOrganizations() {
  const workspace = useWorkspaceStore()
  const query = useMyOrganizations()

  watch(
    () => query.data.value,
    (organizations) => {
      if (organizations) workspace.setOrganizations(organizations)
    },
    { immediate: true },
  )

  return query
}
